import OverlayText from './types/OverlayText';
import OverlaySmiley from './types/OverlaySmiley';
import OverlayButtons from './types/OverlayButtons';
import OverlaySubtitle from './types/OverlaySubtitle';
import OverlayHtml from './types/OverlayHtml';
import OverlayVideoRouter from './types/OverlayVideoRouter';

const Overlay = ({showOverlay, overlay}) => {
    const Overlay = {
        text: OverlayText,
        smiley: OverlaySmiley,
        buttons: OverlayButtons,
        subtitle: OverlaySubtitle,
        html: OverlayHtml,
        videoRouter: OverlayVideoRouter,
    }[overlay.contentType];

    if (!Overlay) {
        console.warn(`Overlay type ${overlay.contentType} doesn't exist...`);
        return null;
    }

    return showOverlay ? <Overlay overlay={overlay} /> : null;
}

export default Overlay;
